/**
 * Verify that a value is a `string`.
 * @param value Value to be verified
 * @throws Throws an error if `value` is not a `string`
 */
export function assertIsString(value: unknown): asserts value is string {
	if (typeof value !== 'string') {
		throw new Error(`Expected 'value' to be a 'string' but was '${typeof value}'.`);
	}
}
